import { useState } from "react";
import axios from "axios";
import "./Searchbar.css";
import { useAuth } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SearchUsers() {
  const { token } = useAuth();
  const [query, setQuery] = useState({
    bloodType: "",
    location: "",
    role: "",
  });

  const [results, setResults] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setQuery({ ...query, [name]: name === "location" ? value.trim() : value });
  };

  const handleSearch = async () => {
    setLoading(true);
    setError("");
    setResults([]);

    if (!query.bloodType || !query.location || !query.role) {
      setError("All fields are required.");
      setLoading(false);
      return;
    }

    if (!token) {
      toast.error("You must be logged in to search!");
      setLoading(false);
      return;
    }

    try {
      const mappedQuery = {
        bloodGroup: query.bloodType,
        location: query.location,
        type: query.role,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/donations/search-users`,
        {
          params: mappedQuery,
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.length === 0) {
        setError("No users found for this location and blood type.");
      } else {
        setResults(response.data);
        setShowModal(true);
      }
    } catch (err) {
      setError("Something went wrong while fetching users.");
    } finally {
      setLoading(false);
    }
  };
  const closeModal = () => setShowModal(false);

  return (
    <div className="search-section">
      <h2 className="title">Search Donors / Receivers</h2>

      <div className="search-fields">
        <select
          name="bloodType"
          value={query.bloodType}
          onChange={handleChange}
        >
          <option value="">Select Blood Type</option>
          <option value="A+">A+</option>
          <option value="A-">A−</option>
          <option value="B+">B+</option>
          <option value="B-">B−</option>
          <option value="O+">O+</option>
          <option value="O-">O−</option>
          <option value="AB+">AB+</option>
          <option value="AB-">AB−</option>
        </select>

        <input
          name="location"
          value={query.location}
          placeholder="Enter Location"
          onChange={handleChange}
        />

        <select name="role" value={query.role} onChange={handleChange}>
          <option value="">Select Role</option>
          <option value="donor">Donor</option>
          <option value="receiver">Receiver</option>
        </select>

        <button onClick={handleSearch} disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {error && <p className="error">{error}</p>}

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <button className="close-btn" onClick={closeModal}>
              ×
            </button>
            <h3>Matching Users ({results.length}):</h3>
            {results.map((user) => (
              <div key={user._id} className="result-card">
                <p>
                  <strong>Name:</strong> {user.fullName}
                </p>
                <p>
                  <strong>Age:</strong> {user.age}
                </p>
                <p>
                  <strong>Mobile Number:</strong> {user.mobile}
                </p>
                <p>
                  <strong>Blood Type:</strong> {user.bloodGroup}
                </p>
                <p>
                  <strong>Location:</strong> {user.address}
                </p>
                <p>
                  <strong>Role:</strong> {user.type}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
